import { render, staticRenderFns } from "./p3s2AccountSetupPaymentDetails.vue?vue&type=template&id=1cb79af3"
import script from "./p3s2AccountSetupPaymentDetails.vue?vue&type=script&lang=js"
export * from "./p3s2AccountSetupPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports